var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasketball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8148 0.0374063C12.5594 0.0212812 12.305 0 12.0469 0C9.09033 0 6.25918 1.12472 4.06946 3.07514L12.0001 11.0057L15.0304 7.97541C12.918 5.86294 12.1359 2.84939 12.8148 0.0374063Z",
    fill: "#FB6910"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.07514 4.0694C1.12472 6.25912 0 9.09027 0 12.0469C0 12.3051 0.0212812 12.5597 0.0374063 12.8151C2.84948 12.1367 5.86355 12.9179 7.97541 15.0303L11.0057 12L3.07514 4.0694Z",
    fill: "#FB6910"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2156 0.20282C13.578 2.59157 14.2232 5.17963 16.0247 6.98113L19.9776 3.02826C18.3329 1.56332 16.3545 0.592914 14.2156 0.20282Z",
    fill: "#FB6910"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9718 4.02252L17.1227 7.87161C19.0261 9.12824 21.4156 9.35882 23.5097 8.55955C23.0174 6.88893 22.1529 5.34852 20.9718 4.02252Z",
    fill: "#FB6910"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87052 17.1237L4.02246 20.9717C5.35146 22.1555 6.8958 23.0208 8.57078 23.5125C8.77323 22.9867 8.91667 22.4355 8.98745 21.8645C9.19647 20.1721 8.78955 18.508 7.87052 17.1237Z",
    fill: "#FB6910"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12.9943L8.87817 16.1161C10.0957 17.8215 10.6461 19.9103 10.3828 22.0375C10.3065 22.6535 10.159 23.2498 9.95508 23.8224C10.61 23.9322 11.2757 24 11.9531 24C14.9097 24 17.7409 22.8753 19.9306 20.9249L12 12.9943Z",
    fill: "#FB6910"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8218 9.94966C22.9101 10.2721 21.9565 10.4418 21.0015 10.4418C19.2829 10.4418 17.5791 9.90049 16.1254 8.86896L12.9944 12L20.925 19.9306C22.8754 17.7408 24.0001 14.9097 24.0001 11.9531C24.0001 11.2738 23.9321 10.6062 23.8218 9.94966Z",
    fill: "#FB6910"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.202759 14.2156C0.592853 16.3544 1.56326 18.3328 3.0282 19.9775L6.98102 16.0247C5.17915 14.2227 2.59038 13.5784 0.202759 14.2156Z",
    fill: "#FB6910"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketball);
export default __webpack_public_path__ + "static/media/basketball.4ba112222458d1f6a92c5de207fe8566.svg";
export { ForwardRef as ReactComponent };